import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // Unique identifier for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Ticket Id'), // Localized column header
                                    minWidth: 150, // Column width
                                    adjust: 'data', // Width adjusts to content
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('Usuario'), // Localized column header
                                    minWidth: 150, // Column width
                                    adjust: 'data', // Width adjusts to content
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    width: 150, // Column width
                                    options: [
                                        // Dropdown options for the state column
                                        { id: 'C', value: _('Abierto') },
                                        { id: 'S', value: _('Ganó') },
                                        { id: 'N', value: _('Perdió') },
                                        { id: 'A', value: _('No Acción') },
                                        { id: 'R', value: _('Pendiente') },
                                        { id: 'W', value: _('En Espera') },
                                        { id: 'J', value: _('Rechazada') },
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'),
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'),
                                        },
                                    ],
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Localized column header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Localized column header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto Premios'), // Localized column header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'TaxBet', // Column ID
                                    header: _('Impuesto Apuesta'), // Localized column header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WinningAmountTotal', // Column ID
                                    header: _('Premio Total'), // Localized column header
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'Odds', // Column ID
                                    header: _('Odds'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserIP', // Column ID
                                    header: _('IP'), // Localized column header
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Wallet', // Column ID
                                    header: _('Billetera'), // Localized column header
                                    width: 100, // Column width
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                details: function (euv, id) {
                                    // Function to handle detail clicks
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Check screen size
                                        $$('filterDetails').show(); // Show filter details for small screens
                                        $$('filterDetails2').show(); // Show second filter details
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                    }
                                },
                            },
                            on: {
                                // Event handlers for DataTable events
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                    // Recalculate ID column widths
                                    this.adjustColumn('Id', 'data');
                                    this.adjustColumn('UserId', 'data');
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA1', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistory?PlayerId=' + cur_user + '&'; // API URL for fetching bet history
        var filter = ''; // Filter string

        // Event listener for filtering data
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add PlayerId to filter string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
